export const LIST_PROTOCOLS = 'LIST_PROTOCOLS'
export const GET_PROTOCOL = 'GET_PROTOCOL'
export const SELECT_PROTOCOL = 'SELECT_PROTOCOL'
